import { Tenant } from "./tenant"
import { UserApiResponse } from "./user"

export type StaffResponseItem = {
    cognitoId?: string
    createdAt?: string
    disabled: boolean
    id: string
    loginEnabled: boolean
    hourlyWage: string
    monthlyWage: string
    overtimeRate: string
    notes?: string
    user: {
        cognitoId?: string
        id: string
        email: string
        firstName: string
        lastName: string
        phone: string
        imageUrl: string

        roles: [
            {
                roleType: string
            }
        ]
    },
    tenant?: Tenant
}

export type Staff = {
    cognito_id?: string
    created_at?: string
    disabled?: boolean
    id: string
    idx?: number
    is_deleted: boolean
    login_enabled: boolean
    hourly_rate: string
    monthly_rate: string
    overtime_rate: string
    user: StaffUser
    notes?: string
}

export type StaffUser = {
    id?: string
    cognito_id?: string
    email: string
    first_name: string
    last_name: string
    phone: string
    image_url?: string
    imageUrl?: string
    role: Role
    createdAt?: string
}

export type StaffModalProps = {
    idx: number
    staff: Staff
}

export type StaffCardActions = {
    editItem: (idx: number) => void
    connectItem: (idx: number) => void
    archiveItem: (s: Staff) => void
    hardDeleteItem: (s: Staff) => void
    restoreItem: (s: Staff) => void
}

export interface RoleItem {
    id: string,
    type: RoleTypes,
    tenant_role_id: string,
}

export type Role = {
    id: string
    text: string
    desc: string
}

export const ROLES: Role[] = [
    {
        id: 'ADMIN',
        text: 'admin',
        desc: 'admin_desc',
    },
    {
        id: 'INSTRUCTOR',
        text: 'instructor',
        desc: 'instructor_desc',
    },
    {
        id: 'LOCATION_MANAGER',
        text: 'location_manager',
        desc: 'location_manager_desc',
    },
    {
        id: 'RECEPTIONIST',
        text: 'receptionist',
        desc: 'receptionist_desc',
    },
    {
        id: 'READ_ONLY',
        text: 'read_only',
        desc: 'read_only_desc',
    },
]

export enum RoleTypes {
    SUPER_ADMIN = 'SUPER_ADMIN',
    ADMIN = 'ADMIN',
    INSTRUCTOR = 'INSTRUCTOR',
    LOCATION_MANAGER = 'LOCATION_MANAGER',
    RECEPTIONIST = 'RECEPTIONIST',
    READ_ONLY = 'READ_ONLY',
}

export type StaffAvailabilityDto = {
    id?: string
    staff: any
    block: boolean
    service_group_id: string
    serviceIds?: string[]
    services?: any[]
    categoryIds?: string[]
    categories?: any[]
    location?: any
    locationSpaceIds?: any[]
    dayOfWeeks?: string[]
    effectiveDate?: string
    expiryDate?: string
    fromTime?: string
    toTime?: string
    createdAt?: string
    allDay?: boolean
}

export type StaffAvailability = {
    id?: string
    staff?: any
    availability: string
    location?: string
    location_space?: string[]
    services?: string[]
    serviceIds?: string[]
    day_of_weeks: string[]
    start_date?: string
    end_date?: string
    from_time?: Date
    to_time?: Date
    created_at?: string
    all_day?: boolean
}

export function denormalizeStaff(staff_xhr: any): Staff[] {
    return (
        staff_xhr?.content?.map((staff: Record<string, string>): Staff => {
            const {
                cognitoId: cognito_id,
                id,
                hourlyWage: hourly_rate,
                monthlyWage: monthly_rate,
                overtimeRate: overtime_rate,
                loginEnabled: login_enabled,
                deletedAt: deleted_at,
                createdAt: created_at,
                disabled,
                notes
            } = staff
            const staff_user = staff.user as unknown as UserApiResponse
            let role: Role = {
                id: '',
                text: '',
                desc: ''
            }
            if (staff_user?.roles && staff_user.roles[0]) {
                const roleType = staff_user.roles[0].roleType
                role = ROLES.find(
                    (item) => item.id === roleType
                ) as Role
            }
            

            return {
                cognito_id,
                id,
                created_at,
                disabled: disabled as unknown as boolean,
                hourly_rate,
                monthly_rate,
                overtime_rate,
                login_enabled: login_enabled as unknown as boolean,
                is_deleted: !!deleted_at,
                user: {
                    cognito_id: staff_user.cognitoId,
                    id: staff_user.id as string,
                    first_name: staff_user.firstName,
                    last_name: staff_user.lastName,
                    phone: staff_user.phone as string,
                    email: staff_user.email,
                    image_url: staff_user.imageUrl as string,
                    role,
                },
                notes
            }
        }) || []
    )
}